import { Criteria } from './criteria';
import { Inheritance } from './inheritance';
import { Part } from './part';
import { ScheduleGroup } from './scheduleGroup';

export class Schedule {
    id: string;
    createDateTimeUtc: Date;
    updateDateTimeUtc: Date;
    name: string;
    action: number;
    description: string;
    category: string;
    isActive: boolean;
    hours: number;
    sensorTypeId: number;
    sensorType: string;
    groups: ScheduleGroup[];
    parts: Part[];
    criteria: Criteria[];
    children: Schedule[];
    inheritance: Inheritance;
    cfrSections: string[]

    displayGroups: string[];
    isSelected: boolean;
    constructor() {
        this.name = '';
        this.action = 0;
        this.description = '';
        this.category = '';
        this.isActive = true;
        this.hours = 0;
        this.sensorTypeId = 0;
        this.groups = new Array<ScheduleGroup>();
        this.parts = new Array<Part>();
        this.criteria = new Array<Criteria>();
        this.children = new Array<Schedule>();
        this.inheritance = new Inheritance();
        this.cfrSections = []
    }
}
